import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export default function Sidebar({ toggleMenu }) {
    const location = useLocation();
    const [toggleSettings, setToggleSettings] = React.useState(false);


    return (
        <aside
            id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="app-brand demo ">
                <Link to="/" className="app-brand-link">
                    <span className="app-brand-logo demo">
                        <span style={{ color: "var(--bs-primary)" }}>
                            <img src="/assets/img/logo.png" alt="" />
                        </span>
                    </span>
                </Link>
                <button onClick={toggleMenu} className="btn layout-menu-toggle menu-link text-large ms-auto" >
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M8.47365 11.7183C8.11707 12.0749 8.11707 12.6531 8.47365 13.0097L12.071 16.607C12.4615 16.9975 12.4615 17.6305 12.071 18.021C11.6805 18.4115 11.0475 18.4115 10.657 18.021L5.83009 13.1941C5.37164 12.7356 5.37164 11.9924 5.83009 11.5339L10.657 6.707C11.0475 6.31653 11.6805 6.31653 12.071 6.707C12.4615 7.09747 12.4615 7.73053 12.071 8.121L8.47365 11.7183Z" fillOpacity="0.9" />
                        <path d="M14.3584 11.8336C14.0654 12.1266 14.0654 12.6014 14.3584 12.8944L18.071 16.607C18.4615 16.9975 18.4615 17.6305 18.071 18.021C17.6805 18.4115 17.0475 18.4115 16.657 18.021L11.6819 13.0459C11.3053 12.6693 11.3053 12.0587 11.6819 11.6821L16.657 6.707C17.0475 6.31653 17.6805 6.31653 18.071 6.707C18.4615 7.09747 18.4615 7.73053 18.071 8.121L14.3584 11.8336Z" fillOpacity="0.4" />
                    </svg>
                </button>
            </div>
            <div className="menu-inner-shadow" />
            <ul className="menu-inner py-1">

                <li className={`menu-item ${location.pathname === '/' && 'active'}`}>
                    <Link to='/' className="menu-link">
                        <i className="menu-icon tf-icons ri-dashboard-line" />
                        <div data-i18n="Dashboard">Dashboard</div>
                    </Link>
                </li>

                <li className={`menu-item ${(location.pathname === '/users' || location.pathname === '/users/view') && 'active'}`}>
                    <Link to='/users' className="menu-link">
                        <i className="menu-icon tf-icons ri-group-line" />
                        <div data-i18n="Manage Users">Manage Users</div>
                    </Link>
                </li>

                <li className={`menu-item ${(location.pathname === '/user-subscriptions' || location.pathname === '/user-subscriptions/view') && 'active'}`}>
                    <Link to='/user-subscriptions' className="menu-link">
                        <i className="menu-icon tf-icons ri-group-line" />
                        <div data-i18n="Manage User Subscriptions">Manage User Subscriptions</div>
                    </Link>
                </li>

                <li className={`menu-item ${location.pathname === '/categories' && 'active'}`}>
                    <Link to='/categories' className="menu-link">
                        <i className="menu-icon tf-icons ri-file-list-3-line" />
                        <div data-i18n="Manage Categories">Manage Categories</div>
                    </Link>
                </li>

                <li className={`menu-item ${location.pathname === '/frequencies' && 'active'}`}>
                    <Link to='/frequencies' className="menu-link">
                        <i className="menu-icon tf-icons ri-profile-line" />
                        <div data-i18n="Manage Frequencies">Manage Frequencies</div>
                    </Link>
                </li>

                <li className={`menu-item ${location.pathname === '/music' && 'active'}`}>
                    <Link to='/music' className="menu-link">
                        <i className="menu-icon tf-icons ri-music-line" />
                        <div data-i18n="Manage Music">Manage Music</div>
                    </Link>
                </li>

                <li className={`menu-item ${location.pathname === '/subscriptions' && 'active'}`}>
                    <Link to='/subscriptions' className="menu-link">
                        <i className="menu-icon tf-icons ri-calendar-todo-line" />
                        <div data-i18n="Manage Plans">Manage Plans</div>
                    </Link>
                </li>

                <li className={`menu-item ${location.pathname === '/transactions' && 'active'}`}>
                    <Link to='/transactions' className="menu-link">
                        <i className="menu-icon tf-icons ri-arrow-right-s-line"></i>
                        <div data-i18n="Manage Transactions">Manage Transactions</div>
                    </Link>
                </li>
                {/* Affiliate menu start */}
                <li className={`menu-item ${toggleSettings ? 'open' : ''}`}>
                    <div onClick={() => setToggleSettings(!toggleSettings)} className="menu-link menu-toggle waves-effect">
                        <i className="menu-icon tf-icons ri-settings-line" />
                        <div data-i18n="Affiliate">Affiliate</div>
                    </div>
                    <ul className="menu-sub collapse" id="collapseAffiliate">
                        <li className={`menu-item ${location.pathname === '/affiliates' && 'active'}`}>
                            <Link to='/affiliates' className="menu-link">
                                <div data-i18n="Manage User Affiliates">Manage User Affiliates</div>
                            </Link>
                        </li>
                        <li className={`menu-item ${location.pathname === '/admin/affiliates' && 'active'}`}>
                            <Link to='/admin/affiliates' className="menu-link">
                                <div data-i18n="Manage Admin Affiliates">Manage Admin Affiliates</div>
                            </Link>
                        </li>
                        <li className={`menu-item ${location.pathname === '/payouts' && 'active'}`}>
                            <Link to='/payouts' className="menu-link">
                                <div data-i18n="Manage Payout"> Manage Payout</div>
                            </Link>
                        </li>
                        <li className={`menu-item ${location.pathname === '/affiliate-settings' && 'active'}`}>
                            <Link to='/affiliate-settings' className="menu-link">
                                <div data-i18n="Affiliate Settings">Affiliate Settings</div>
                            </Link>
                        </li>
                    </ul>
                </li>
                {/* Affiliate menu end */}

                <li className={`menu-item ${location.pathname === '/templates' && 'active'}`}>
                    <Link to='/templates' className="menu-link">
                        <i className="menu-icon tf-icons ri-mail-line"></i>
                        <div data-i18n="Manage Email Templates"> Manage Email Templates</div>
                    </Link>
                </li>
                {/* delta amount */}
                <li className={`menu-item ${location.pathname === '/delta-amount' && 'active'}`}>
                    <Link to='/delta-amount' className="menu-link">
                        <i className="menu-icon tf-icons ri-line-chart-line"></i>
                        <div data-i18n="Users Delta Amount">Users Delta Amount</div>
                    </Link>
                </li>
            </ul>
        </aside>
    )
}